import {gsap} from "../../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {Point, Ticker} from 'pixi.js';

// Constructor
export class AppearingContainer extends PIXI.Container {

  constructor(appearingScreenPercent, game) {
    super();

    this.game = game;
    this.appearingScreenPercent = appearingScreenPercent;
    this.ticker = game.ticker;

    this.inAnimation = null;
    this.mainAnimation = null;

    // No need to render the element if it's not ready to be shown
    this.renderable = false;
  }

  build() {
    // to be overwritten in child
  }

  buildAnimations() {
    // to be overwritten in child
  }

  getPositionOnScreen() {
    // Could be overwritten in the child class
    // For example in TextPopup the container is at 0,0 always but we want to check for the text position
    return this.toGlobal(new Point(0, 0));
  }

  // Function called when the game progression hit the appearingScreenPercent value
  animateIn() {
    if (this.inAnimation) {
      this.inAnimation.play();
    }

    if (typeof this.animateInAddons === "function") {
      this.animateInAddons();
    }
  }

  // Function to start the main animation loop
  animate() {
    if (this.mainAnimation) {
      this.mainAnimation.play();
    }
  }

  // Could be used if you want to hide the object
  // animateOut() {
  //   this.outAnimation.play();
  // }

  // Loop that checks to see if we show the element or not
  checkProgression() {

    if (!this.renderable && this.getPositionOnScreen().x > -this.width) {
      // The object is either on screen or to the right of the screen AND not rendered
      // If the object comes in screen, it will start to render and animateIn
      if (this.getPositionOnScreen().x <= (this.game.appWidth * this.appearingScreenPercent)) {
        this.renderable = true;
        this.animateIn();
      }

    } else if (this.renderable && this.getPositionOnScreen().x <= -this.width) {
      // The object went past the screen and is now offscreen to the left
      // No need to render it anymore as it will never show again
      this.renderable = false;
      this.ticker.remove(this.checkProgression, this);
    }

  }

  // Reset the states so we can animate in again and start over
  reset() {
    if (this.inAnimation) {
      this.inAnimation.kill();
      this.inAnimation = null;
    }

    if (this.mainAnimation) {
      this.mainAnimation.kill();
      this.mainAnimation = null;
    }

    // Rebuild the animations
    this.buildAnimations();

    // Reset the progression check
    this.ticker.remove(this.checkProgression, this);
    this.ticker.add(this.checkProgression, this);

    this.renderable = false;
  }


}
